import { UpdatePatientStatusModal } from './UpdatePatientStatusModal';
import { PatientDetailsProtocolConfirmation } from './PatientDetailsProtocolConfirmation';
import { RecontactedPatientModal } from './RecontactedPatientModal';
import { PatientVisit601StatusReminder } from './PatientVisit601StatusReminder';
import { AddExternalReferralModal } from './AddExternalReferralModal';
import { RequestMedicalRecordsConsentModal } from './RequestMedicalRecordsConsentModal/RequestMedicalRecordsConsentModal';

export * from './ModalContainer/ModalContainer';

export const Modals = {
  UpdatePatientStatus: UpdatePatientStatusModal,
  ProtocolConfirmation: PatientDetailsProtocolConfirmation,
  RecontactedPatient: RecontactedPatientModal,
  PatientVisit601StatusReminder: PatientVisit601StatusReminder,
  AddExternalReferral: AddExternalReferralModal,
  RequestMedicalRecordsConsent: RequestMedicalRecordsConsentModal,
};
